import { combineReducers } from 'redux';

import testListReducer from './test-list';
import testCaseReducer from './test-case';

const reducers = {
  testList: testListReducer,
  testCase: testCaseReducer,
};

export default combineReducers(reducers);
